export enum InboxThreadActions {
  SET_IS_LOADING = 'SET_IS_LOADING',
  UPDATE_UNREAD_INBOX_THREADS_COUNT = 'UPDATE_UNREAD_INBOX_THREADS_COUNT',
}

export function setIsLoading(isLoading: boolean) {
  return {
    type: InboxThreadActions.SET_IS_LOADING,
    payload: { isLoading },
  }
}

export function updateUnreadInboxThreadsCount(unreadReviewsCount: number, unreadTodosCount: number) {
  return {
    type: InboxThreadActions.UPDATE_UNREAD_INBOX_THREADS_COUNT,
    payload: { unreadReviewsCount, unreadTodosCount },
  }
}
